var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"maildate"},[_vm._v(_vm._s(_vm.dateStr))]),_c('ul',_vm._l((_vm.dateMessage.messages),function(message){return _c('message-history-log',{key:message.id,attrs:{"message":message}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }